//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Design() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Design e comunicação minimalista
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que o software científico deve apresentar, em todas as comunicações com o usuário, apenas as informações 
              relevantes para a realização da tarefa. Além disso, o software deve apresentar um design de interface simples e minimalista que busque diminuir possibilidades 
              de serem cometidos erros pelos usuários. Exemplo: Em uma situação na qual o usuário realizou o upload de um arquivo em um formato que não é aceito pelo software, 
              deve ser informado de forma simples e direta qual o erro cometido e quais os formatos de arquivos aceitos. </strong> </p>
            <p align="justify"> <strong> A heurística Design e comunicação minimalista foi subdivida em dois critérios de análise, a saber: Controle das comunicações realizadas 
              para o usuário (C1) e Controle dos elementos secundários (C2). </strong> </p>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C1) Durante as comunicações com o usuário apenas as informações relevantes para a realização da tarefa atual são apresentadas? Indique o número de comunicações analisadas (N) 
                e a quantidade de comunicações coerentes encontradas (Q). Exemplo: Em uma tarefa que se divide em passos, apenas as informações relevantes para a conclusão do passo atual 
                ficam disponíveis na tela. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de comunicações analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de comunicações coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P2.C1)   Durante as comunicações com o usuário os textos são diretos e orienta o usuário na realização da tarefa atual? Indique o número de textos analisados (N) e a 
                quantidade de textos coerentes encontrados (Q). Exemplo: No uso da técnica de Placeholder em um formulário que requisita uma data para o usuário, informar 
                ’Data no formato DD/MM/AAAA. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de textos analisados:  &nbsp; </span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de textos coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C2)   Durante as comunicações com o usuário, os elementos que compõem a interface mas não estão envolvidos diretamente na realização da tarefa mantém 
                o seu comportamento ou perdem destaque? Indique o número de elementos analisados (N) e a quantidade de elementos coerentes encontrados (Q). Exemplo: Quando 
                o usuário clica em um botão uma janela aparece na tela para ele continuar a tarefa em os demais elementos recebem uma coloração diferente. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de elementos analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de elementos coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>

            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>





          </div>
        </div>
      </div>

    </div>
  );
}
